import { getEmailParticipants } from '../../Email.utils'
import { EmailTableRowParticipants } from '../../EmailTableRowParticipants'

function EmailThreadsModalTableRowParticipants(props) {
  return (
    <EmailTableRowParticipants {...props} getItems={getEmailParticipants} />
  )
}

export default EmailThreadsModalTableRowParticipants
